module.exports = __webpack_public_path__ + "img/arrow-up-circle-fill.9bbfc044.svg";